export default {
  cn: { code: 'cn', name: '中国', dialCode: 86, phoneFormat: '131 2345 6789' },
  us: { 'code': 'us', 'name': '美国', 'dialCode': 1, 'phoneFormat': '(201) 555-0123' },
  au: {
    code: 'au',
    name: '澳大利亚',
    dialCode: 61,
    phoneFormat: '0412 345 678'
  },
  jp: { code: 'jp', name: '日本', dialCode: 81, phoneFormat: '090-1234-5678' },
  tw: { code: 'tw', name: '台湾', dialCode: 886, phoneFormat: '0912 345 678' },
  mo: { code: 'mo', name: '澳门', dialCode: 853, phoneFormat: '6612 3456' },
  hk: { code: 'hk', name: '香港', dialCode: 852, phoneFormat: '5123 4567' },
  kr: { code: 'kr', name: '韩国', dialCode: 82, phoneFormat: '010-0000-0000' },
  ca: {
    code: 'ca',
    name: '加拿大',
    dialCode: 1,
    phoneFormat: '(204) 234-5678'
  },
  gg: { code: 'gg', name: '英国', dialCode: 44, phoneFormat: '07781 123456' },
  fr: { code: 'fr', name: '法国', dialCode: 33, phoneFormat: '06 12 34 56 78' },
  de: { code: 'de', name: '德国', dialCode: 49, phoneFormat: '01512 3456789' },
  it: { code: 'it', name: '意大利', dialCode: 39, phoneFormat: '312 345 6789' },
  in: { code: 'in', name: '印度', dialCode: 91, phoneFormat: '099876 54321' },
  ru: {
    code: 'ru',
    name: '俄罗斯',
    dialCode: 7,
    phoneFormat: '8 (912) 345-67-89'
  },
  pt: { code: 'pt', name: '葡萄牙', dialCode: 351, phoneFormat: '912 345 678' },
  ph: {
    code: 'ph',
    name: '菲律宾',
    dialCode: 63,
    phoneFormat: '0905 123 4567'
  },
  pk: {
    code: 'pk',
    name: '巴基斯坦',
    dialCode: 92,
    phoneFormat: '0301 2345678'
  },
  no: { code: 'no', name: '挪威', dialCode: 47, phoneFormat: '406 12 345' },
  nz: { code: 'nz', name: '新西兰', dialCode: 64, phoneFormat: '021 123 4567' },
  nl: { code: 'nl', name: '荷兰', dialCode: 31, phoneFormat: '06 12345678' },
  mn: { code: 'mn', name: '蒙古', dialCode: 976, phoneFormat: '8812 3456' },
  mx: {
    code: 'mx',
    name: '墨西哥',
    dialCode: 52,
    phoneFormat: '044 222 123 4567'
  },
  my: {
    code: 'my',
    name: '马来西亚 ',
    dialCode: 60,
    phoneFormat: '012-345 6789'
  },
  lu: { code: 'lu', name: '卢森堡', dialCode: 352, phoneFormat: '628 123 456' },
  lt: {
    code: 'lt',
    name: '立陶宛',
    dialCode: 370,
    phoneFormat: '(8-612) 34567'
  },
  la: {
    code: 'la',
    name: '老挝',
    dialCode: 856,
    phoneFormat: '020 23 123 456'
  },
  ie: {
    code: 'ie',
    name: '爱尔兰',
    dialCode: 353,
    phoneFormat: '085 012 3456'
  },
  il: {
    code: 'il',
    name: '以色列',
    dialCode: 972,
    phoneFormat: '050-123-4567'
  },
  id: {
    code: 'id',
    name: '印度尼西亚',
    dialCode: 62,
    phoneFormat: '0812-345-678'
  },
  gr: { code: 'gr', name: '希腊', dialCode: 30, phoneFormat: '691 234 5678' },
  fi: { code: 'fi', name: '芬兰', dialCode: 358, phoneFormat: '041 2345678' },
  ko: { code: 'ko', name: '南韩', dialCode: 82, phoneFormat: '' },
  kh: { code: 'kh', name: '柬埔寨', dialCode: 855, phoneFormat: '091 234 567' },
  br: { code: 'br', name: '巴西', dialCode: 55, phoneFormat: '(11) 96123-4567' }
}
